import React, { useState } from 'react';
import { Button } from '../../../components/ui';
import AddEditUserModal from './AddEditUserModal';
import { useUpdateUser } from '../../../mutation/user';

export default function EditUserButton({ user }) {
  const { mutate: mutateUpdateUser, isLoading } = useUpdateUser();
  const [showModal, setShowModal] = useState(false);
  return (
    <>
      <Button
        className="users__edit-btn"
        loading={isLoading}
        type="button"
        onClick={() => setShowModal(true)}
      >
        Edit User
      </Button>
      <AddEditUserModal
        isVisible={showModal}
        user={user}
        onHide={() => setShowModal(false)}
        onSaveUser={newUser => {
          setShowModal(false);
          mutateUpdateUser(newUser);
        }}
      />
    </>
  );
}
